var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "a-select",
      class: {
        compact: _vm.compact,
        focused: _vm.isFocused,
        empty: !_vm.isNotEmpty,
      },
    },
    [
      _vm.compact
        ? _c(
            "button",
            {
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  _vm.isDropdownOpen = true
                },
              },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.compact
        ? [
            _c("input", {
              directives: [
                {
                  name: "focus",
                  rawName: "v-focus",
                  value: _vm.isAutofocus,
                  expression: "isAutofocus",
                },
              ],
              ref: "search",
              attrs: { type: "search", disabled: _vm.isDisabled },
              domProps: { value: _vm.search },
              on: {
                input: _vm.changeAvailableOptions,
                focus: _vm.onFocus,
                blur: _vm.onBlur,
                click: _vm.onFocus,
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "up", 38, $event.key, [
                        "Up",
                        "ArrowUp",
                      ])
                    ) {
                      return null
                    }
                    return _vm.typeAheadUp.apply(null, arguments)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "down", 40, $event.key, [
                        "Down",
                        "ArrowDown",
                      ])
                    ) {
                      return null
                    }
                    return _vm.typeAheadDown.apply(null, arguments)
                  },
                ],
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onEnter.apply(null, arguments)
                },
              },
            }),
            _vm._v(" "),
            _vm.label
              ? _c("label", [_vm._v(_vm._s(_vm.appliedLabel))])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.selected, function (option) {
              return _vm.multiple
                ? _c("a-select-tag", {
                    key: option[_vm.optionKey],
                    attrs: { tagText: option[_vm.optionLabel] },
                    on: {
                      deselect: function ($event) {
                        return _vm.deselect(option)
                      },
                    },
                  })
                : _vm._e()
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isDropdownOpen,
              expression: "isDropdownOpen",
            },
            {
              name: "on-clickaway",
              rawName: "v-on-clickaway",
              value: _vm.hideDropdown,
              expression: "hideDropdown",
            },
          ],
          staticClass: "dropdown-wrap",
        },
        [
          _vm.compact
            ? _c("input", {
                directives: [
                  {
                    name: "focus",
                    rawName: "v-focus",
                    value: true,
                    expression: "true",
                  },
                ],
                ref: "searchcompact",
                attrs: { type: "search", disabled: _vm.isDisabled },
                domProps: { value: _vm.search },
                on: {
                  input: _vm.changeAvailableOptions,
                  focus: _vm.onFocus,
                  blur: _vm.onBlur,
                  click: _vm.onFocus,
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      ) {
                        return null
                      }
                      return _vm.typeAheadUp.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      ) {
                        return null
                      }
                      return _vm.typeAheadDown.apply(null, arguments)
                    },
                  ],
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onEnter.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("a-select-dropdown", {
            attrs: {
              options: _vm.getOptions(),
              selectedOptions: _vm.selected,
              optionLabel: _vm.optionLabel,
              optionKey: _vm.optionKey,
              typeAheadPointer: _vm.typeAheadPointer,
              align: _vm.align,
              multiple: _vm.multiple,
              compact: _vm.compact,
              cohort: _vm.userCohort,
            },
            on: {
              hide: function ($event) {
                _vm.isDropdownOpen = false
              },
              select: _vm.select,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
      _vm._v(" "),
      _vm.required && !_vm.isNotEmpty
        ? _c("span", { staticClass: "error" }, [
            _vm._v(_vm._s(_vm.requiredMessage)),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }